import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Typography,
} from "@material-ui/core";
import Button from "../Button/Button";
import "./DialogConfirmation.css";

type DialogConfirmationProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: React.ReactNode;
  confirmLabel: string;
  cancelLabel: string;
};

const DialogConfirmation: React.FC<DialogConfirmationProps> = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel,
  cancelLabel,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        className: "dialogConfirmationCard",
      }}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle className="dialogConfirmationTitle">
        {title}
      </DialogTitle>
      <DialogContent className="dialogConfirmationContent">
        <Typography className="dialogConfirmationMessage">
          {message}
        </Typography>
      </DialogContent>
      <DialogActions className="dialogConfirmationActions">
        <Button
          variant="outline"
          onClick={onClose}
          className="dialogConfirmationButton dialogConfirmationButtonCancel"
        >
          {cancelLabel}
        </Button>
        <Button
          variant="neutral"
          onClick={onConfirm}
          className="dialogConfirmationButton dialogConfirmationButtonConfirm"
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogConfirmation;
